import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<div class=\"bv-card__subsection\" ...attributes>\n  {{yield}}\n</div>",{ moduleName: "volta/components/bv-card/subsection.hbs" })